<template>
  <a-modal
    width="1200px"
    :title="currentItem.name"
    v-model:visible="visible"
    :footer="false">
  <div class="dataset-detail">
   <!-- <div class="detail-page-title">
      {{ info.name }}
      <a-button type="primary">返回</a-button>
    </div>-->
    <a-tabs @change="callback">
      <a-tab-pane key="1" tab="任务信息">
        <div class="paragraph-title">
          基本信息
        </div>
        <div class="info-wrap">
          <div class="info-item">
            <div class="label">任务ID：</div>
            <div class="value">{{ currentItem.id }}</div>
          </div>
          <div class="info-item">
            <div class="label">名称：</div>
            <div class="value">{{ currentItem.name }}</div>
          </div>
          <div class="info-item">
            <div class="label">任务类型：</div>
            <div class="value">{{ getTaskName(currentItem.taskTypeId) }}</div>
          </div>
          <div class="info-item">
            <div class="label">说明：</div>
            <div class="value">{{ currentItem.description?currentItem.description:'--' }}</div>
          </div>
          <div class="info-item">
            <div class="label">发布人：</div>
            <div class="value">{{ currentItem.creator }}</div>
          </div>
          <div class="info-item">
            <div class="label">任务量：</div>
            <div class="value">{{ taskNumber }}</div>
          </div>
          <div class="info-item">
            <div class="label">创建时间：</div>
            <div class="value">{{ getDateTime(currentItem.createTime) }}</div>
          </div>
          <div class="info-item">
            <div class="label">要求完成时间：</div>
            <div class="value">{{ getDateTime(currentItem.planFinishTime) }}</div>
          </div>
        </div>
        <div class="paragraph-title">
          审核信息
        </div>
        <div class="info-wrap">
          <div class="info-item">
            <div class="label">状态：</div>
            <div class="value">{{ currentItem.state }}</div>
          </div>
          <div class="info-item">
            <div class="label">审核进度：</div>
            <div class="value">{{ currentItem.progress?currentItem.progress:'--' }}</div>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="审核数据">
        <div class="pic-wrap">
          <div class="pic-item"
            v-for="(item, index) in picList"
            :key="index">
            <img :src="item.url" alt="" @click="openPicDialog">
            <p class="name">{{ item.name }}</p>
          </div>
        </div>
        <a-pagination
          :current="page.pageNum"
          show-quick-jumper
          :pageSize="10"
          :total="total"
          :show-total="total => `共 ${total} 条`"
          @change="getPics"
        ></a-pagination>
      </a-tab-pane>
    </a-tabs>
    <PicDialog ref="picDialog"></PicDialog>
  </div>
  </a-modal>
</template>
<script>
import PicDialog from '../PicDialog'
import { getDateTime, getTaskName, getTeamName } from '@/filters'
import { getTagLabel } from '@/api/tagLabel'
import { getDataByPage } from '@/api/dataItem'
export default {
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    },
    addition: {
      type: String,
      default: () => ''
    }
  },
  components: {
    PicDialog
  },
  data () {
    return {
      visible: false,
      info: {
        list1: [],
        list2: []
      },
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      picList: [
        {
          name: '1',
          url: ''
        },
        {
          name: '2',
          url: ''
        },
        {
          name: '3',
          url: ''
        },
        {
          name: '4',
          url: ''
        },
        {
          name: '5',
          url: ''
        },
        {
          name: '6',
          url: ''
        },
        {
          name: '7',
          url: ''
        },
        {
          name: '8',
          url: ''
        },
        {
          name: '9',
          url: ''
        },
        {
          name: '10',
          url: ''
        }
      ],
      taskNumber: ''
    }
  },
  methods: {
    getDateTime,
    getTaskName,
    getTeamName,
    open () {
      this.visible = true
      this.picList = []
      this.$nextTick(() => {
        this.getPics(1)
        this.getDataItems()
      })
    },
    callback (key) {
      console.log(key)
    },
    getPics (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      getTagLabel({ ...this.page, id: this.currentItem.intermediaryId }).then(res => {
        this.total = res.data.map.data.total
        this.picList = res.data.map.data.rows
      })
    },
    getDataItems () {
      const addition = this.addition
      const params = Object.fromEntries(addition.split('&').map(str => str.split('=')))
      getDataByPage({ ...this.page, ...params }).then(res => {
        const data = res.data.map.data
        this.taskNumber = data.total
      })
    },
    openPicDialog () {
      this.$refs.picDialog.open()
    }
  }
}
</script>
<style lang="less">
.dataset-detail {
  .info-wrap {
    display: flex; flex-wrap: wrap;
    .info-item {
      width: 25%;
      padding: 20px; box-sizing: border-box;
      display: flex;
      div:first-child{
        width: 100px;
        text-align: right;
      }
      div:last-child{
        width: calc(100% - 100px);
      }
    }
    .custom-table {
      width: 30%;
      padding: 20px; box-sizing: border-box;
      .table-row {
        display: flex;
      }
    }
  }
  .pic-wrap {
    display: flex; flex-wrap: wrap;
    .pic-item {
      padding: 10px; box-sizing: border-box;
      width: 20%; text-align: center;
      img {
        width: 100%; height: 120px;
      }
    }
  }
}
</style>
